// extracted by mini-css-extract-plugin
export var hidden = "_3v-1";
export var leftPanel = "_3v-2";
export var readonlyInspector = "_3v-3";
export var rightPanel = "_3v-0";